module.exports = __webpack_public_path__ + "img/code.4b452e9b.png";